import type { LeftNavStorageBarProps } from './components/LeftNavStorageBar';
import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, LazyModule, LazyImport, type LazyComponent } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "Storage" */ './lazyIndex'),
    {
        name: 'Storage',
    }
);

export const LazyLeftNavStorageBar: LazyComponent<LeftNavStorageBarProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.LeftNavStorageBar);

export const StorageUpsellBanner: LazyComponent<{}, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.StorageUpsellBanner
);

export const lazyOpenStorageWarning: LazyImport<
    typeof lazyIndex.openStorageWarning,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.openStorageWarning);

export const lazyNavigateToStoragePage: LazyImport<
    typeof lazyIndex.navigateToStoragePage,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.navigateToStoragePage);
